import React, { useEffect, useRef, useState } from 'react';
import Modal from './Modal';
import Spinner from './Spinner';
import { del, get } from '../services/api';
import swishLogo from '../assets/img/swish-logo-name.png';

const MAX_ATTEMPTS = 10;
let attempts = 0;

// eslint-disable-next-line no-promise-executor-return
const timeout = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

function Swish({ order, callback }) {
  const [showPaymentInfo, setShowPaymentInfo] = useState(order.orderId);
  // const [errorMessage, setErrorMessage] = useState(null);
  const [failedValidation, setFailedValidation] = useState(null);

  const myRef = useRef(null);
  const executeScroll = () => myRef.current.scrollIntoView();

  useEffect(() => {
    setShowPaymentInfo(order.orderId);
    executeScroll();
  }, [order]);

  useEffect(() => {
    (async () => {
      if (showPaymentInfo) {
        // Wait for 10 extra seconds before validation of payment starts
        await timeout(10000);
        validatePayment();
      }
    })();
  }, [showPaymentInfo]);

  const validatePayment = async () => {
    attempts += 1;

    if (attempts >= MAX_ATTEMPTS) {
      setFailedValidation(
        'Vi har inte mottagit någon betalning ännu. Har du betalt, klicka på "Validera betalning" nedan.'
      );
      // callback({ status: 'UNKNOW' });
      return;
    }

    await timeout(1000 * attempts);

    const { response } = await get(`orders/${showPaymentInfo}/swish/check`);
    if (!response?.paymentId || response.paymentStatus === 'CREATED') {
      validatePayment();
      return;
    }

    // Status can be PAID OR ERROR
    callback({ status: response.paymentStatus, paymentResponse: response });
  };

  const retryValidation = () => {
    attempts = 0;
    setFailedValidation(null);
    validatePayment();
  };

  const cancelPayment = () => {
    del(`orders/${showPaymentInfo}/swish`);
    callback({ status: 'CANCELLED' });
  };

  // const error = errorMessage || failedValidation;
  const error = failedValidation;

  return (
    <Modal show close={null}>
      <div className="swish" ref={myRef}>
        <img src={swishLogo} style={{ maxHeight: '40px', borderBottom: 0 }} alt="swish" />

        {!error && showPaymentInfo && (
          <>
            <h4>Öppna din Swish-app på din mobiltelefon och godkänn betalningen</h4>
            <p className="mt-3">
              Du kommer automatiskt att skickas till orderbekräftelsesidan när betalningen är godkänd.
            </p>
            <div className="d-flex align-items-center">
              <Spinner />
              <p className="mb-0 ml-2">Väntar på betalningen...</p>
            </div>
          </>
        )}
        {error && (
          <>
            <p className="golfamore-error">{error}</p>
            <div className="d-flex justify-content-end align-items-center">
              <button type="button" className="button m-3" onClick={retryValidation}>
                Validera betalning
              </button>
              <button type="button" className="button cancel" onClick={cancelPayment}>
                Avbryt
              </button>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
}

export default Swish;
